<template>
  <div class="login-hzk">
    <el-form
      class="layui-form layui-form-pane"
      :model="loginForm"
      rule="rules"
      ref="loginForm"
    >
      <dl class="admin_login clear-fix">
        <dt>
          <em
            ><img src="static/login/images/logo2.png" alt="合作库云数据平台"
          /></em>
          <strong>合作库云数据平台</strong>
        </dt>
        <dd>
          <label class="layui-form-label layui-form-label-logo">
            <i class="fa fa-user"></i>账号</label
          >
          <div class="layui-input-inline layui-form-label-logo1">
            <input
              type="text"
              v-model="loginForm.UserName"
              placeholder="请输入账号"
              autocomplete="off"
              class="layui-input"
            />
          </div>
        </dd>
        <dd>
          <label class="layui-form-label layui-form-label-logo">
            <i class="fa fa-lock"></i>密码</label
          >
          <div class="layui-input-inline layui-form-label-logo1">
            <input
              type="password"
              v-model="loginForm.Password"
              placeholder="请输入密码"
              autocomplete="off"
              class="layui-input"
            />
          </div>
        </dd>
        <dd>
          <div>
            <button
              class="layui-btn layui-btn-normal"
              type="button"
              @click="submitForm"
            >
              立即提交
            </button>
          </div>
        </dd>
        <dd>
          <a
            @click="loginHelpDialog = true"
            href="javascript:;"
            class="fr btn-color-blur1 login-btn1"
            >获取账号</a
          >
          <el-popover placement="left" width="160" trigger="hover">
            <div>
              请联系客服：<br />0755-82405890-8931<br />或者发送邮件到：<br />atm8123@spr-atm.com
            </div>
            <div slot="reference">
              <a href="javascript:;" class="btn-color-blur1 tips1"
                >忘记密码？</a
              >
            </div>
          </el-popover>
        </dd>
        <dd>
          <p class="center admin_login-text">© 2017 前海高扬版权所有</p>
        </dd>
      </dl>
    </el-form>
    <canvas id="canvas"></canvas>
    <el-dialog title="温馨提示 ！" size="tiny" :visible.sync="loginHelpDialog">
      <div class="popup-login">
        <div class="popup-content clear-fix pd-20">
          <div class="popup-login-text">
            <p>
              合作库只针对参与合作库业务的用户进行开放，在合作库进行托管、寄售，租赁，维修等业务的用户我们会在第一时间将账号和密码发送到您指定邮箱，通过此账号您可以在合作库上查询您一切与合作库有关的信息！
            </p>
            <p><strong>如有疑问请您联系：</strong></p>
            <p>客服电话：0755-82405890-8931</p>
            <p>
              客服邮箱：<a href="mailto:atm8123@spr-atm.com"
                >atm8123@spr-atm.com</a
              >
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="homeFooter">
      <div class="footerBox">
        Copyright © 深圳前海高扬科技有限公司
        <a href="https://beian.miit.gov.cn" target="blank">粤ICP备19007655号</a>
        <div id="ebsBox" class="ebsBox" style="float: right"></div>
      </div>
      <div id="ebs2" style="width: 36px; height: 42px; display: none">
        <img
          id="ebsgovicon"
          src="https://szcert.ebs.org.cn/govicons.js?id=e7c51040-bbd2-4318-850a-eb404b32e2ed&width=100&height=137&type=1"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { SPR_TOKEN } from '@/constant'
export default {
  data: function () {
    return {
      loginHelpDialog: false, // 是否显示获取账号按钮的弹出框
      loginForm: {
        UserName: '',
        Password: '',
      },
      rules: {
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        Password: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      const form = this.$refs.loginForm
      form.validate((valid) => {
        if (valid) {
          window.localStorage.removeItem('NO_ALERT')
          // login action
          const usernameOrEmailAddress = this.loginForm.UserName
          const password = this.loginForm.Password
          const url = process.env.LOGIN_URL
          this.$http
            .post(url, { usernameOrEmailAddress, password })
            .then(({ data }) => {
              const userInfo = data.result
              // 获取之前登录记录,如果登录人不同则清除缓存
              let beforeLogin = JSON.parse(
                window.localStorage.getItem('CURRENT_USER')
              )
              if (beforeLogin) {
                // 有登录记录
                if (
                  userInfo.customer.customerCode !==
                  beforeLogin.customer.customerCode
                ) {
                  window.localStorage.clear()
                }
              } else {
                // 无登录记录也清除缓存
                window.localStorage.clear()
              }
              // 保存登录用户信息到缓存
              window.localStorage.setItem(
                'CURRENT_USER',
                JSON.stringify(userInfo)
              )
              window.localStorage.setItem(SPR_TOKEN, userInfo.result)
              this.$message('登陆成功')
              console.log('user', data.result)
              if (data.result.isPrimaryAccount) {
                // 如果是主账户跳转到首页
                window.location.href = '/'
              } else {
                var permissions = JSON.parse(data.result.customer.permissions)
                console.log('permissions', permissions)
                console.log('permissions[0]', permissions[0])
                if (permissions) {
                  window.location.href = '#' + permissions[0]
                }
              }
            })
            .catch((err) => {
              this.$alert(err.message)
            })
        } else {
          return false
        }
      })
    },
  },
  mounted() {
    // 获取index.html中的市场监督电子标识DOM
    let script = document.getElementById('ebs')
    script.setAttribute('style', 'width:18px;height:21px;display:show')
    // 添加到底部文字中
    document.getElementById('ebsBox').appendChild(script)
    /* eslint-disable */
    // 背景绘制
    setTimeout(() => {
      'use strict'
      var canvas = document.getElementById('canvas'),
        ctx = canvas.getContext('2d'),
        w = (canvas.width = window.innerWidth),
        h = (canvas.height = window.innerHeight),
        hue = 217,
        stars = [],
        count = 0,
        maxStars = 1400

      // Thanks @jackrugile for the performance tip! http://codepen.io/jackrugile/pen/BjBGoM
      // Cache gradient
      var canvas2 = document.createElement('canvas'),
        ctx2 = canvas2.getContext('2d')
      canvas2.width = 100
      canvas2.height = 100
      var half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half)
      gradient2.addColorStop(0.025, '#fff')
      gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)')
      gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)')
      gradient2.addColorStop(1, 'transparent')

      ctx2.fillStyle = gradient2
      ctx2.beginPath()
      ctx2.arc(half, half, half, 0, Math.PI * 2)
      ctx2.fill()

      // End cache

      function random(min, max) {
        if (arguments.length < 2) {
          max = min
          min = 0
        }

        if (min > max) {
          var hold = max
          max = min
          min = hold
        }

        return Math.floor(Math.random() * (max - min + 1)) + min
      }

      var Star = function () {
        this.orbitRadius = random(w / 2 - 50)
        this.radius = random(100, this.orbitRadius) / 10
        this.orbitX = w / 2
        this.orbitY = h / 2
        this.timePassed = random(0, maxStars)
        this.speed = random(this.orbitRadius) / 900000
        this.alpha = random(2, 10) / 10

        count++
        stars[count] = this
      }

      Star.prototype.draw = function () {
        var x = Math.sin(this.timePassed + 1) * this.orbitRadius + this.orbitX,
          y = (Math.cos(this.timePassed) * this.orbitRadius) / 2 + this.orbitY,
          twinkle = random(10)

        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05
        }

        ctx.globalAlpha = this.alpha
        ctx.drawImage(
          canvas2,
          x - this.radius / 2,
          y - this.radius / 2,
          this.radius,
          this.radius
        )
        this.timePassed += this.speed
      }

      for (var i = 0; i < maxStars; i++) {
        new Star()
      }

      function animation() {
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 0.8
        ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 1)'
        ctx.fillRect(0, 0, w, h)

        ctx.globalCompositeOperation = 'lighter'
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw()
        }

        window.requestAnimationFrame(animation)
      }

      animation()
    }, 500)
  },
}
</script>

<style lang="less" scoped>
canvas {
  z-index: 1;
  position: absolute;
  height: 100%;
  top: 0;
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
body {
  color: #263443;
}
.login-hzk {
  background: #050c19;
  overflow: hidden;
  a:hover,
  a:active {
    color: #01aaed;
    text-decoration: none;
  }
  span {
    display: inline-block;
  }
  img {
    display: inline-block;
    max-width: 100%;
    vertical-align: top;
    max-height: 100%;
  }
  .clear-fix:after {
    clear: both;
    content: ' ';
    display: block;
    height: 0;
    visibility: hidden;
    font-size: 0;
  }
  .clear {
    clear: both;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .pt-10,
  .pt-15,
  .pt-20,
  .pt-25,
  .pt-30 {
    clear: both;
  }
  .pt-10 {
    padding-top: 10px;
  }
  .pt-15 {
    padding-top: 15px;
  }
  .pt-20 {
    padding-top: 20px;
  }
  .pt-25 {
    padding-top: 25px;
  }
  .pt-30 {
    padding-top: 30px;
  }
  .pd-10 {
    padding: 10px;
  }
  .pd-20 {
    padding: 20px;
  }
  .center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .main-left {
    float: left;
    width: 200px;
    background: #324057;
    height: 100%;
  }
  .logo {
    text-align: center;
    padding: 10px;
  }
  .main-left-nav {
    height: calc(100% - 100px);
  }
  .main-left-h {
    height: 50px;
  }
  .layui-nav {
    background: #324057;
  }
  .layui-nav-itemed > a,
  .layui-nav-tree .layui-nav-title a,
  .layui-nav-tree .layui-nav-title a:hover {
    background: #324057 !important;
  }
  .layui-nav-tree .layui-nav-child a {
    background: #1f2d3d;
  }
  /*.layui-nav-item>a{background: #273244;}*/
  .layui-nav-tree .layui-nav-child a:hover {
    background: #5e6d82;
  }
  .layui-nav-item i {
    padding-right: 5px;
  }
  .main-left-nav .optiscroll-vtrack,
  .main-left-nav .optiscroll-htrack {
    background: red;
  }
  .m-wrapper {
    width: 100%;
    height: 100%;
  }
  .column {
    width: 40%;
    height: 15rem;
    background: #f6f2f2;
    padding: 10px;
  }
  a.layui-this {
    color: #20a0ff !important;
  }
  /*.layui-nav-tree .layui-nav-child dd.layui-this, .layui-nav-tree .layui-this, .layui-nav-tree .layui-this>a, .layui-nav-tree .layui-this>a:hover{background: #5E6D82;}*/
  /*.layui-nav-tree .layui-nav-bar{background: #5E6D82;}*/
  .layui-laypage .layui-laypage-curr .layui-laypage-em {
    background: #01aaed;
  }
  .layui-form-checkbox[lay-skin='primary'] i {
    line-height: 14px;
  }
  .layui-form-checkbox[lay-skin='primary']:hover i {
    border-color: #01aaed;
  }
  .layui-form-checked[lay-skin='primary'] i {
    background: #01aaed;
    border-color: #01aaed;
  }
  .layui-table,
  .layui-tab {
    margin: 0;
  }
  .layui-input:hover,
  .layui-textarea:hover,
  .layui-input:focus,
  .layui-textarea:focus {
    border-color: #01aaed !important;
  }
  .layui-form-danger + .layui-form-select .layui-input,
  .layui-form-danger:focus {
    border-color: #ff5722 !important;
  }
  .layui-btn {
    vertical-align: top;
    margin: 0 5px 0 0;
  }
  .layui-nav-tree .layui-nav-bar {
    background-color: #01aaed;
  }
  .layui-nav-tree .layui-nav-child dd.layui-this,
  .layui-nav-tree .layui-this,
  .layui-nav-tree .layui-this > a,
  .layui-nav-tree .layui-this > a:hover {
    background: #324057;
    color: #01aaed;
  }
  .layui-table td,
  .layui-table th {
    word-break: keep-all;
    padding: 9px; /*white-space: nowrap;text-overflow: ellipsis;*/
  }
  .layui-table1 td,
  .layui-table1 th {
    word-break: normal;
    padding: 9px;
    white-space: normal !important;
  }
  .layui-form-select dl dd.layui-this {
    background: #01aaed;
  }
  .layui-btn + .layui-btn {
    margin: 0 5px 0 0;
  }
  .layui-form-radio i:hover,
  .layui-form-radioed i {
    color: #01aaed;
  }
  /*scroll*/
  .scroll {
    overflow: hidden;
    position: relative;
  }
  .scroll-menu {
    overflow: hidden;
  }
  .layui-nav .layui-nav-child a {
    padding: 0 10px 0 42px;
  }
  /*main-right*/
  .main-right {
    width: calc(100% - 200px);
    float: left;
    background: #eff3f6;
    height: 100%;
  }
  .main-title {
    height: 60px;
    background: #fff;
    padding: 0 20px;
  }
  .main-title a {
    line-height: 60px;
    font-size: 16px;
  }
  .main-title a i {
    font-size: 18px;
    margin-top: -2px;
    vertical-align: middle;
  }
  .main-content {
    height: calc(100% - 60px);
    width: 100%;
  }
  .main-pt {
    padding: 20px;
  }
  /*login*/
  .logo-text {
    color: #fff;
    font-size: 16px;
  }
  .admin_login {
    width: 351px;
    height: auto;
    overflow: hidden;
    margin: 10% auto 0 auto;
    padding: 30px;
    box-shadow: 0 0 10px #01aaed;
    border-radius: 5px;
    position: relative;
    z-index: 2;
  }
  .admin_login dt {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    text-shadow: 0 0 1px #01aaed;
    margin-bottom: 15px;
  }
  .admin_login dt strong {
    display: block;
    font-weight: 400;
    padding-top: 5px;
  }
  .admin_login dt em {
    display: block;
    font-size: 12px;
    margin-top: 8px;
  }
  .admin_login dd {
    padding: 5px 0;
    overflow: hidden;
    position: relative;
  }
  .admin_login button {
    width: 100%;
  }
  .admin_login-text {
    color: #a1b9da;
  }
  .layui-form-pane .layui-form-label-logo {
    background: #a1b9da;
    border-color: #a1b9da;
  }
  .layui-form-label-logo1 .layui-input {
    background: #cde2fe;
    border-color: #cde2fe;
  }
  .layui-form-label-logo i {
    padding-right: 8px;
  }
  .layui-form-pane .layui-form-label-logo {
    width: 80px;
  }
  .layui-form-label-logo1 {
    width: 212px;
  }
  /*content*/
  .label-for1 {
    float: left;
    display: block;
    padding: 9px 10px 9px 0;
  }
  .layui-inline1 {
    padding: 0 10px 10px 0;
  }
  .layui-inline2 {
    width: 292px;
    display: inline-block;
  }
  .layui-inline2 .layui-form-label {
    padding: 9px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .layui-tab1 {
    padding-top: 20px;
  }
  .layui-tab-title1 .layui-this {
    background: #fff;
    color: #01aaed;
  }
  .layui-tab-title1 li {
    padding: 0 20px;
  }
  .layui-tab-title1 li:hover {
    color: #01aaed;
  }
  .layui-tab-content-bg {
    background: #fff;
    border: solid 1px #e2e2e2;
    border-top: none;
  }
  .layui-btn-primary {
  }
  .layui-btn-primary:hover {
    color: #01aaed;
    border-color: #01aaed;
  }
  .admin {
    padding-right: 10px;
  }
  .user-wp {
    padding: 10px;
    background: #fff;
    margin-top: 20px;
  }
  .user-wp1 {
    padding: 10px;
    background: #fff;
    height: 100%;
  }
  .user-wp2 {
    padding: 10px;
    background: #fff;
  }
  .layui-form-label1 {
    width: 10em;
  }
  .basic-title {
    font-size: 24px;
    line-height: 1.2em;
    padding: 20px 0;
  }
  .main-welcome {
    padding-top: 100px;
  }
  .main-welcome-text {
    font-size: 30px;
    line-height: 1.5em;
  }
  .layui-form1 .layui-btn {
    vertical-align: top;
  }
  /*popup*/
  .popup-title {
    background: #324057;
    color: #fff;
    font-size: 16px;
    padding: 10px;
  }
  .label-for2 {
    width: 6em;
    text-align: right;
  }
  .form-color {
    color: #ff5722;
    padding-right: 8px;
  }
  .form-item {
    padding-bottom: 15px;
  }
  .layui-form-label {
    width: 110px;
  }
  /*上传*/
  .site-demo-upload,
  .site-demo-upload img {
    width: 200px;
    height: 200px;
    border-radius: 100%;
  }
  .site-demo-upload {
    position: relative;
    background: #e2e2e2;
  }
  .site-demo-upload .site-demo-upbar {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -18px 0 0 -56px;
  }
  .site-demo-upload .layui-upload-button {
    background-color: rgba(0, 0, 0, 0.2);
    color: rgba(255, 255, 255, 1);
  }
  .layui-layer {
    max-height: 90%;
    max-width: 98%;
  }
  .layui-upload-icon i {
    color: #86dbfd;
  }
  .popup-user2 {
    max-width: 628px;
  }
  .popup-wp1 {
    max-width: 628px;
  }
  .popup-user-wp1 {
    max-width: 628px;
  }
  .popup-user-wp2 {
    min-width: 600px;
  }
  /*上传2*/
  ul#gallery {
    list-style: none;
    padding: 0 20px;
    border: 1px solid #eee;
    background: #fff;
    overflow: hidden;
  }
  ul#gallery li {
    float: left;
    padding: 20px 20px 20px 0;
  }
  ul#gallery li:last-child {
    padding: 20px 0;
  }
  ul#gallery li a.smallimage {
    display: block;
    width: 200px;
    height: 125px;
    overflow: hidden;
    text-align: center;
    line-height: 125px;
    border: solid 1px #eee;
    position: relative;
    cursor: default;
  }
  ul#gallery li a.smallimage:hover {
    border-color: #01aaed;
  }
  a.smallimage img {
    vertical-align: middle;
    margin-top: -2px;
  }
  #bigimage {
    position: absolute;
    display: none; /*大图片的父标签设置相对定位并将显示样式设置为隐藏*/
    z-index: 198910150;
  }
  #bigimage img {
    padding: 5px;
    background: #fff;
    border: 1px solid #e3e3e3;
    max-height: 500px;
    max-width: 800px;
  }
  .basic-title1 {
    font-size: 16px;
    padding-bottom: 15px;
  }
  ul#gallery li a.smallimage .close1 {
    position: absolute;
    top: 2px;
    right: 2px;
    display: none;
    line-height: 30px;
    cursor: pointer;
  }

  .img-box {
    margin-top: 40px;
  }
  .img-box .up-p {
    margin-bottom: 20px;
    font-size: 16px;
    color: #555;
  }
  .z_photo {
    padding: 18px;
    border: 1px dashed #e7e6e6;
  }
  .z_photo .z_file {
    position: relative;
  }
  .z_file .file {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .z_photo .up-section {
    position: relative;
    margin-right: 20px;
  }
  .z_photo .up-section:last-child {
    margin-right: 0;
  }
  .up-section .close-upimg {
    position: absolute;
    top: 6px;
    right: 8px;
    display: none;
    z-index: 10;
  }
  .up-section .up-span {
    display: block;
    width: 100%;
    height: 100%;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.2);
  }
  .up-section:hover {
    border: 1px solid #01aaed;
  }
  .up-section:hover .close-upimg {
    display: block;
    cursor: pointer;
  }
  .up-section:hover .up-span {
    visibility: visible;
  }
  .z_photo .up-img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .up-opcity {
    opacity: 0;
  }
  .img-name-p {
    display: none;
  }
  .upimg-div .up-section {
    width: 200px;
    height: 125px;
    border: 1px dashed #e7e6e6;
  }
  .img-box .upimg-div .z_file {
    width: 200px;
    height: 125px;
    border: 1px dashed #e7e6e6;
  }
  .z_file .add-img {
  }
  .mask {
    z-index: 198910150;
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
  .mask .mask-content {
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -250px;
    margin-top: -80px;
    background: white;
    height: 160px;
    text-align: center;
  }
  .mask .mask-content .del-p {
    color: #555;
    height: 94px;
    line-height: 94px;
    font-size: 18px;
    border-bottom: 1px solid #d1d1d1;
  }
  .mask-content .check-p {
    height: 66px;
    line-height: 66px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .mask-content .check-p span {
    width: 50%;
    display: inline-block;
    text-align: center;
    color: #01aaed;
    font-size: 18px;
    cursor: pointer;
  }
  .check-p .del-com {
    border-right: 1px solid #d1d1d1;
  }
  .add-img {
    font-size: 18px;
    text-align: center;
    line-height: 1.8em;
    padding-top: 30px;
  }
  .add-img i {
    font-size: 24px;
  }
  .layui-table-mini {
    border: solid 1px #f8f8f8;
  }
  .layui-input-mini {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    width: 50px;
  }
  .layui-table-mini .input-fr {
    float: right;
  }
  .layui-table-mini[lay-even] tr:nth-child(even) {
    background-color: #fff;
  }
  .layui-table-mini[lay-even] tr:hover {
    background: #f8f8f8;
  }
  .layui-table-b {
    border: none !important;
    border-bottom: solid 1px #e2e2e2 !important;
  }
  .layui-table-b th,
  .layui-table-b td {
    border: none !important;
  }
  .layui-table-b2 {
    border: none !important;
  }
  .layui-table-b2 th {
    border: none !important;
  }
  .checkbox-bold {
    font-weight: bold;
  }
  .text-right .layui-btn + .layui-btn {
    margin: 0 0 0 5px;
  }
  .text-right .layui-btn {
    margin: 0;
  }
  .checkbox2 .layui-form-checkbox[lay-skin='primary'] span {
    min-width: 5em;
  }
  .checkbox3 .layui-form-checkbox[lay-skin='primary'] span {
    min-width: 8em;
  }
  .checkbox4 .layui-form-checkbox[lay-skin='primary'] span {
    min-width: 4em;
  }
  .max-wp {
    max-width: 550px;
  }
  .user-distribution {
    position: relative;
    margin-right: 15px;
    cursor: default;
  }
  .user-distribution-pa {
    position: absolute;
    top: -8px;
    right: -12px;
    display: none;
  }
  .user-distribution-pa a {
    background: #ff4949;
    color: #fff;
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: inline-block;
    text-align: center;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
  }
  .user-distribution-pa a .layui-icon {
    font-size: 12px;
    vertical-align: middle;
  }
  .user-distribution:hover .user-distribution-pa {
    display: block;
  }
  .checkbox5 span {
    padding-bottom: 8px;
  }

  /*权限树*/
  .tree {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
  }
  .tree li {
    list-style-type: none;
    margin: 0;
    padding: 10px 5px 0 5px;
    position: relative;
  }
  .tree li::before,
  .tree li::after {
    content: '';
    left: -20px;
    position: absolute;
    right: auto;
  }
  .tree li::before {
    border-left: 1px solid #999;
    bottom: 50px;
    height: 100%;
    top: 0;
    width: 1px;
  }
  .tree li::after {
    border-top: 1px solid #999;
    height: 20px;
    top: 25px;
    width: 25px;
  }
  .tree li span {
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border: 1px solid #999;
    border-radius: 5px;
    display: inline-block;
    padding: 3px 8px;
    text-decoration: none;
  }
  .tree li.parent_li > span {
    cursor: pointer;
  }
  .tree > ul > li::before,
  .tree > ul > li::after {
    border: 0;
  }
  .tree li:last-child::before {
    height: 30px;
  }
  .tree li.parent_li > span:hover,
  .tree li.parent_li > span:hover + ul li span {
    background: #eee;
    border: 1px solid #94a0b4;
    color: #000;
  }
  .tree ul {
    margin: 0 0 10px 25px;
  }
  .tree > ul > li > ul > li ul {
    margin: 0 0 0 25px !important;
  }
  .tree a {
    color: #01aaed;
  }
  .tree a:hover {
    text-decoration: underline;
  }

  .popup-user4 {
    position: relative;
  }
  .popup-content {
  }
  .position-a1 {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: -5px;
    padding: 10px 28px 20px;
    background: #fff;
  }
  .height-btn {
    height: 63px;
  }
  a.btn-color-blur1 {
    color: #a1b9da;
  }
  a.btn-color-blur1:hover {
    color: #00aeef;
  }

  .popup-login-text {
    max-width: 400px;
    line-height: 1.8em;
  }
  .popup-login-text p {
    text-indent: 2em;
  }
  // 2017/11/7 YBL 底部
  .homeFooter {
    z-index: 2;
    color: #a1b9da;
    position: relative;
    margin-top: 180px;
  }
  .homeFooter .footerBox {
    width: 400px;
    height: 21px;
    margin: 0 auto;
    display: block;
  }
  .homeFooter a {
    color: #a1b9da;
  }
  .homeFooter a:hover {
    color: #01aaed;
  }
}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?510c7f42